import {getCachedTableStateSlice} from 'src/hooks/common-data-service/cached-table';

import type {CachedTableStateSelector} from 'src/hooks/common-data-service/cached-table/typedef';
import type {EntitlementsFilters} from 'src/modules/entitlements/typedef';

export const accountDatasetEntitlementsStateSlice = getCachedTableStateSlice<
    undefined,
    undefined,
    EntitlementsFilters
>('accountDatasetEntitlementsState', undefined);

export const accountDatasetEntitlementsStateActions = accountDatasetEntitlementsStateSlice.actions;
export const accountDatasetEntitlementsStateSelector: CachedTableStateSelector<
    undefined,
    undefined,
    EntitlementsFilters
> = state => state.accountPage.tabs.datasetEntitlements.state;
